<template>
  <div class="app-container" style="min-height: calc(100vh - 84px);">
    <el-tabs v-model="tabName" @tab-click="handleClick">
      <el-tab-pane label="考勤设备" name="Device">
        <device-list ref="DeviceList" :disabled="!$permission.canRead()">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button size="mini" type="success" plain @click="improtDevice" v-if="!isMB">导入</el-button>
            <el-button size="mini" type="primary" plain @click="exportDevice" v-if="!isMB">导出</el-button>
            <el-button size="mini" type="primary" @click="create">添加</el-button>
            <el-button size="mini" type="danger" @click="delRows">删除</el-button>
          </template>
          <template slot="column" v-if="$permission.canWrite()">
            <el-table-column fixed="right" label="操作" width="60" align="center">
              <template slot-scope="{row}">
                <el-button size="mini" type="text" icon="el-icon-edit" @click="edit(row)" />
              </template>
            </el-table-column>
          </template>
        </device-list>
      </el-tab-pane>
    </el-tabs>
    <device-dialog ref="DeviceDialog" @close-saved="reload" />
    <device-import ref="deviceImport" @upload-success="reload" />
  </div>
</template>
<script>
import deviceList from "@/components/sys/setting/device/list";
import deviceDialog from "@/components/sys/setting/device/editDialog";
import deviceImport from "@/components/sys/setting/device/importDialog";

export default {
  name: "setting",
  components: {
    deviceList,
    deviceDialog,
    deviceImport,
  },
  data() {
    return {
      tabName: "Device",
      select: {
        Id: null,
        Name: "",
      },
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    this.reload();
  },
  methods: {
    improtDevice() {
      this.$refs.deviceImport.open();
    },
    exportDevice() {
      this.$refs.DeviceList.export();
    },
    handleClick() {
      this.reload();
    },
    reload() {
      this.$refs[this.tabName + "List"].reload();
      this.$nextTick(() => {
        this.$refs[this.tabName + "List"].$refs.list.$refs.table.doLayout();
      });
    },
    create() {
      this.$refs[this.tabName + "Dialog"].openCreate();
    },
    edit(row) {
      console.log("edit");
      this.$refs[this.tabName + "Dialog"].open().then((that) => {
        that.setData(row);
      });
    },
    del(row) {
      this.$refs[this.tabName + "List"].delete(row);
    },
    delRows() {
      let rows = this.$refs[this.tabName + "List"].getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item[this.tabName + "Id"];
          });
          // console.log("this.tabName", this.tabName);
          // console.log("ids", ids);
          this.$refs[this.tabName + "List"].delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>